import { useTranslation } from "react-i18next";
import { LANG_KEY, resolveBaseLanguage } from "../../i18n";
import { useTheme } from "../../contexts/ThemeContext";

/** Native labels stay fixed so both scripts remain visible in either UI language. */
const LANGUAGES = [
  { code: "en", label: "English", langAttr: "en" },
  { code: "ur", label: "اردو", langAttr: "ur" },
];

export default function LanguageSwitcher({ className = "" }) {
  const { i18n, t } = useTranslation();
  const { mounted } = useTheme();
  const current = resolveBaseLanguage(i18n.resolvedLanguage || i18n.language || "en");
  const activeIndex = Math.max(
    0,
    LANGUAGES.findIndex((lang) => lang.code === current),
  );

  const handleSelect = (code) => {
    if (code === current) return;
    i18n.changeLanguage(code);
    localStorage.setItem(LANG_KEY, code);
  };

  if (!mounted) {
    return null;
  }

  return (
    <div
      className={`language-switcher language-switcher--slider ${className}`.trim()}
      role="group"
      aria-label={t("language.label")}
    >
      <span
        className="language-switcher__thumb"
        style={{ "--lang-index": activeIndex }}
        aria-hidden
      />
      {LANGUAGES.map((lang) => {
        const selected = current === lang.code;
        return (
          <button
            key={lang.code}
            type="button"
            className={`language-switcher__option${selected ? " is-active" : ""}`}
            aria-pressed={selected}
            lang={lang.langAttr}
            onClick={() => handleSelect(lang.code)}
          >
            {lang.label}
          </button>
        );
      })}
    </div>
  );
}
